/* ============================================================
   GOURMAX V2 · interactions
   - reveal-on-scroll
   - carousel arrows
   - header scroll-shadow
   ============================================================ */
(function () {
  'use strict';

  // ── 1. Reveal on scroll ──────────────────────────────────
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.gx-reveal').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

    document.querySelectorAll('.gx-reveal').forEach(function (el) { io.observe(el); });
  }

  // ── 2. Header scroll-shadow ──────────────────────────────
  function initHeaderShadow() {
    var header = document.querySelector('.gx-h');
    if (!header) return;
    var lastY = -1;
    function onScroll() {
      var y = window.scrollY || window.pageYOffset;
      if ((y > 8) === (lastY > 8)) return;
      lastY = y;
      header.classList.toggle('is-scrolled', y > 8);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ── 3. Carousel arrows ───────────────────────────────────
  function initCarousels() {
    document.querySelectorAll('[data-gx-scroll]').forEach(function (scroller) {
      var prevBtn = scroller.parentElement.querySelector('[data-gx-scroll-prev]');
      var nextBtn = scroller.parentElement.querySelector('[data-gx-scroll-next]');
      var amount = parseInt(scroller.dataset.gxScrollAmount, 10) || 320;
      if (prevBtn) prevBtn.addEventListener('click', function () { scroller.scrollBy({ left: -amount, behavior: 'smooth' }); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scroller.scrollBy({ left:  amount, behavior: 'smooth' }); });
    });
  }

  // ── 4. FAQ accordion enhancement (graceful — <details> works native) ─
  // No-op; <details>/<summary> handles it.

  // ── boot ─────────────────────────────────────────────────
  function boot() {
    initReveal();
    initHeaderShadow();
    initCarousels();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
